// JSON Schema used as Chrome Prompt API responseConstraint / structured output.

export const AI_RESPONSE_SCHEMA = {
  type: 'object',
  additionalProperties: false,
  properties: {
    operations: {
      type: 'array',
      items: {
        type: 'object',
        additionalProperties: false,
        properties: {
          method: { type: 'string' },
          params: { type: 'object' },
        },
        required: ['method', 'params'],
      },
    },
    reply: { type: 'string' },
  },
  required: ['operations', 'reply'],
} as const;
